// Presentation-only formatting helpers. No money arithmetic happens here —
// amounts arrive from the server as integer minor units and are rendered by
// minorToMoney in imports/api/invoices.

// Hours always carry one decimal so a partial hour reads as legitimate rather
// than as a rounding artifact: "4.0 h", never "4h".
export function formatHours(hours) {
  const value = Number(hours);
  return `${Number.isFinite(value) ? value.toFixed(1) : '0.0'} h`;
}

// Totals name their currency. An operator and a payer can be in different
// countries, and a bare "$1,240.00" is ambiguous between them.
export function withCurrency(formattedAmount, currency) {
  return currency ? `${formattedAmount} ${currency}` : formattedAmount;
}
